import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/styles/main.css'

// Apply the persisted color theme before mount so there is no flash of the
// wrong theme. 'blue' is the default and carries no data-theme attribute.
const savedTheme = localStorage.getItem('xs-theme')
if (savedTheme === 'gold') {
  document.documentElement.dataset.theme = 'gold'
}

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')
